import { SHOW_NOTIFICATION } from './actionType'

export function showNotification(isShown, message, type) {
  return {
    type: SHOW_NOTIFICATION,
    payload: {
      isShown,
      message,
      type,
    },
  }
}
